import { m } from "framer-motion";

export const mentalplus = {
  mentalplus_tab_help: 'My buoy',
  mentalplus_tab_videos: 'Videos',
  mentalplus_tab_home: 'My world',
  mentalplus_tab_evolution: 'Progress',
  mentalplus_tab_account: 'Account',
  mentalplus_account_page_title: 'Account and settings',
  mentalplus_account_manage: 'Manage my account',
  mentalplus_account_deactivate: 'Deactivate my account',
  mentalplus_account_deactivate_message: 'Do you want to deactivate your account?',
  mentalplus_account_notifications: 'Manage notifications',
  mentalplus_account_notification_email: 'Email notifications',
  mentalplus_account_notification_sms: 'SMS notifications',
  mentalplus_account_notification_push: 'Push notifications',
  mentalplus_account_notification_add_contact: 'Add a contact to enable this notification',
  mentalplus_account_notification_push_hint: 'Enable to receive notifications on this device',
  mentalplus_account_notification_push_permission_required: 'Permission denied. Enable notifications in browser or device settings.',
  mentalplus_account_tutorials: 'View tutorials',
  mentalplus_account_language: 'Change language',
  mentalplus_account_about: 'About',
  mentalplus_account_contact: 'Contact us',
  mentalplus_account_app_version: 'App version',
  mentalplus_filtre_ile: 'Island',
  mentalplus_tab_ile_moi: 'Me',
  mentalplus_tab_ile_amour: 'Love',
  mentalplus_tab_ile_famille: 'Family',
  mentalplus_tab_ile_amis: 'Friends',
  mentalplus_tab_ile_ecrans: 'Screen',
  mentalplus_tab_ile_loisirs: 'Leisure',
  mentalplus_video_filtres: 'Filters',
  mentalplus_video_enregistrees: 'Saved',
  mentalplus_videos_enregistrees: 'Saved videos',
  mentalplus_video_rechercher: 'Search',
  mentalplus_help_signes: 'Signs',
  mentalplus_help_solutions: 'Solutions',
  mentalplus_help_num_soutiens: 'Support numbers',
  mentalplus_help_signes_question: 'What are the signs that make me realize I’m starting to feel unwell?',
  mentalplus_help_solutions_question: 'What solutions can help me feel better?',
  mentalplus_help_num_epingle: 'Pinned number',
  mentalplus_help_num_utiles: 'Useful numbers',
  mentalplus_help_num_epingle_choix: 'Choose the number to pin',
  mentalplus_help_num_valider: 'Confirm this number',
  mentalplus_help_num_gerer: 'Manage my emergency numbers',
  mentalplus_help_num_gerer_proches: 'Manage my close contacts’ numbers',
  mentalplus_help_num_enregistrer: 'Save',
  mentalplus_help_solutions_ajouter: 'Add a solution',
  mentalplus_help_ajouter: 'Add',
  mentalplus_help_signes_ajouter: 'Add a sign',
  mentalplus_help_num_proches_ajouter: 'Add a close contact',
  mentalplus_help_num_proches_nom: 'Contact name (ex: Dad)',
  mentalplus_help_num_proches_nom_numero: 'Phone number',
  mentalplus_help_num_urgences: 'Emergency numbers',
  mentalplus_help_num_proches: 'Close contacts',
  mentalplus_video_retour: 'Back',
  mentalplus_video_tout_voir: 'See all',
  mentalplus_video_renitialiser: 'Reset',
  mentalplus_filtre_categories: 'Categories',
  mentalplus_filtre_categories_explications: 'Explanations',
  mentalplus_filtre_categories_solutions: 'Solutions',
  mentalplus_filtre_realisee: 'Made by',
  mentalplus_filtre_realisee_professionnels: 'Professionals',
  mentalplus_filtre_realisee_communaute: 'Community',
  mentalplus_filtre_realisee_2: 'Made for',
  mentalplus_filtre_realisee_collegiens: 'Middle school students',
  mentalplus_filtre_realisee_lyceens: 'High school students',
  mentalplus_filtre_realisee_etudiants: 'University students',
  mentalplus_filtre_realisee_jeunes_actifs: 'Young active people',
  mentalplus_filtre_realisee_sans_activite: 'Without activity',
  mentalplus_filtre_trier: 'Sort by',
  mentalplus_filtre_trier_popularite: 'Popularity',
  mentalplus_filtre_trier_recent: 'Recent',
  mentalplus_filtre_trier_ancien: 'Old',
  mentalplus_menu_share: 'Share Mental+',
  mentalplus_menu_profile: 'Profile',
  mentalplus_menu_island_settings: 'Island settings',
  menu_share: 'Share',
  mentalplus_menu_conatct: 'Contact Us',
  mentalplus_menu_objet: 'Subject',
  mentalplus_menu_objet_champ: 'Select a subject',
  mentalplus_menu_equipe: 'Who are we?',
  mentalplus_menu_signaler_un_bug: 'Report a bug',
  mentalplus_menu_contacter_l_equipe: 'Contact the team',
  mentalplus_menu_autre: 'Other',
  mentalplus_menu_que_faire: 'What to do?',
  mentalplus_menu_son: 'Sound',
  mentalplus_video_recherche: 'No video matches these filters.',
  mentalplus_ile_moi_quizz: 'Anxiety and depression quiz',
  mentalplus_video_enregistree: 'No videos saved for now.',
};